export default {
  'completeprofile.completeprofile': 'شروع فرآیند تکمیل پروفایل',
  'completeprofile.maintext':
    'برای تکمیل موارد مختلف پروفایل و دریافت امتیاز مثبت لطفا با فشردن گزینه تکمیل پروفایل ، فرایند را کامل کنید ',
};
